import React, { useState, useEffect, useRef } from 'react';
import update from 'react-addons-update'; // ES6
import classnames from 'classnames';
import './App.scss';
import excuses from './excuses.js';
var dateFormat = require('dateformat');

function randomIntFromInterval(min, max) { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay + randomIntFromInterval(-1000,0));
      return () => clearInterval(id);
    }
  }, [delay]);
}

function random(array) {
	return array[Math.floor(Math.random() * array.length)];
}

// the state machine for the chat
class Chat {
  begin = [
    {m: "hey down to grab a coffee sometime?", delay: 3500 },
    {me: true, m: "sure! it's been wayyy too long", delay: 1000 },
    {me: true, m: "things are a little crazy rn", delay: 1000},
    {me: true, m: "but lets make it work", delay: 2500},
  ];

  busy = [
    "sorry, can't do",
    "I'm busy then",
    "oh that doesnt work",
    "can't do it",
    "that's a bad time",
    "can't",
    "nope, can't make that",
    "that doesn't work",
    "not a good time",
  ]

  proposeStart = [
    "what about",
    "how about",
    "I could do",
    "I could do",
    "",
    "",
    "",
  ]

  constructor() {
    this.step = 0;
    this.queue = [];
    this.state = "proposal-me";
    this.time = new Date();
    this.now = new Date();
    this.time.setMinutes(0);
  }

  nextTime() {
    let delta = random([60, 120, 240, 480, 480, 240]);

    if (this.time.getHours() > 15) {
      delta = 60 * 15;
    }

    this.time = new Date(this.time.getTime() + delta*60000);
  }

  displayTime() {

    let format = "ddd, htt";

    var Difference_In_Time = this.time.getTime() - this.now.getTime();
  
    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    if (Difference_In_Days > 7) {
      format = "mmm d, htt";
    }

    return dateFormat(this.time, format).toLowerCase();
  }

  next() {
    let out;
    
    if (this.step < this.begin.length) {
      out = this.begin[this.step];
    } else {
      switch (this.state) {
        
        case "proposal-them":          
          this.nextTime();
          
          out = { m:`${random(this.proposeStart)} ${this.displayTime()}?` };
          this.state = "busy-me";
          break;

        case "proposal-me":
          this.nextTime();

          out = { me: true, m:`${random(this.proposeStart)} ${this.displayTime()}?` };
          this.state = "busy-them";
          break;

        case "busy-them":
          out = { m: `${random(this.busy)}. ${random(excuses)}`};
          this.state = "proposal-them";
          break;

        case "busy-me":
          out = { me: true, m: `${random(this.busy)}. ${random(excuses)}`};
          this.state = "proposal-me";
          break;          


      }
    }

    this.step += 1;

    return out;
  }

}

const sendAudio = new Audio('send.mp3');
sendAudio.volume = 0.4;
const receiveAudio = new Audio('receive.mp3');
receiveAudio.volume = 0.2;

function App() {

  const [messages, setMessages] = useState([]);
  const [chat, setChat] = useState(null);
  const [delay, setDelay] = useState(3000);
  const bottom = useRef(null);

  let scrollToBottom = () => {
    //document.documentElement.scrollTop = bottom.current.offsetTop;
    //bottom.current.scrollIntoView();
    //bottom.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });

    window.scroll({
      top: bottom.current.offsetTop,
      behavior: 'smooth'
    });

  }

  useEffect(() => {
    setChat(new Chat());
  }, []);

  useInterval(() => {
    let next = chat.next();

    // if (next.delay) {
    //   setDelay(next.delay);
    // }
    
    setMessages(update(messages, { $push: [ next ] }));
    
      if (next.me) {
        sendAudio.play()
        .then(() => {})
        .catch((e) => {

        });
      } else {
        receiveAudio.play()
        .then(() => {})
        .catch((e) => {

        });
      }  
    
    
    scrollToBottom();
  }, delay);


  return (

    <>
      <div className="noise-wrapper">
      <div className="noise"></div>    
      </div>
      
      <div id="app" >
        
        <div className="chat">
        {messages.length == 0 &&
          <div className="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        }
        
          {messages.map((message,i) => {
            return (<div className={classnames('messages', { mine: message.me, yours: !message.me })} key={i}>
              <div className={classnames('message', { last: i == messages.length-1 })}>
                {message.m}
              </div>
            </div>);
          })}
          <div 
              ref={bottom}>
          </div>
        </div>
      </div>
    </>

  );
}


export default App;

